// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3Ncvu","choiceBoxes":"toolbarselects_choiceBoxes__2qdoL","simpleField":"toolbarselects_simpleField__31xyt"};